import { TAB_ID } from 'constants/providerInfoTabIds';

export const ROOM_DETAIL_QUERY = 'viewRoomDetail';
export const PLAN_DETAIL_QUERY = 'viewPlanDetail';
export const SUGGESTED_MEDIA_COUNT = 1;
export const SUGGESTED_FEATURE_COUNT = 0;

const COMMON_TAB_OPEN_RAT_COMPID: Partial<Record<string, string>> = {
  [TAB_ID.OVERVIEW]: 'hotel:overview_tab',
  [TAB_ID.ROOMS_AND_PLANS]: 'hotel:rooms_and_plans_tab',
  [TAB_ID.REVIEWS]: 'hotel:reviews_tab',
  [TAB_ID.HIGHLIGHTS]: 'hotel:highlights_tab',
};

export const PC_TAB_OPEN_RAT_COMPID: Partial<Record<string, string>> = {
  ...COMMON_TAB_OPEN_RAT_COMPID,
  [TAB_ID.INFO]: 'hotel:facilities_tab',
};

export const SP_TAB_OPEN_RAT_COMPID: Partial<Record<string, string>> = {
  ...COMMON_TAB_OPEN_RAT_COMPID,
  [TAB_ID.INFO]: 'hotel:Basic_info_tab',
};
